import { graphql } from "../gql";

export const getFileDownloadUrlQueryDoc = graphql(`
  query getFileDownloadUrl($id: ID!) {
    fileDownloadUrl(id: $id) {
      ...SignedDownloadUrlFragment
    }
  }
`);
